export const BASE_URL = process.env.REACT_APP_BACKEND_URL ?? 'https://simpledev-antonio.herokuapp.com'
